import { createRegisterableComposition } from '@news-mono/web-common'
import React from 'react'
import { Box, BreakPointProps } from '../../compositions/Box/Box'
import { ContainerWidth, ThemeMargins } from '../../__styling/settings/metrics'
import { BaseCompositionProps } from '../types'

export interface BoxRouteProps extends BaseCompositionProps {
    hasTopSpacing?: boolean
    verticalSpacing?: keyof ThemeMargins
    horizontalSpacing?: keyof ThemeMargins
    horizontalGutters?: keyof ThemeMargins
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    containerWidth?: ContainerWidth
    breakpoints?: BreakPointProps
    hasBackgroundFill?: boolean
    fillContainer?: boolean
    positionOffset?: {
        direction: 'top' | 'bottom'
        value: number
    }
    containerHeight?: number | undefined
    stickyOffset?: number | undefined
}

export const BoxRegistration = createRegisterableComposition<'main'>()(
    'box',
    (contentAreas, props: BoxRouteProps) => (
        <Box {...props}>{contentAreas.main}</Box>
    ),
)
